import "./HowItWorks.module.css";
import Header from "@/reusable_sections/Header";
import AITechPackDevelopment from "./sections/AITechPackDevelopment";
import KeyBenefits from "./sections/KeyBenefits";
import TheSolutionFlow from "./sections/TheSolutionFlow";
import CommonQuestions from "./sections/CommonQuestions";
import HowItWorks from "./sections/HowItWorks";
import GetYourStrategy from "./sections/GetYourStrategy";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function HowItWorksPage() {
  return <div>
      <Header />
      <AITechPackDevelopment />
      <KeyBenefits />
      <TheSolutionFlow />
      <HowItWorks />
      <CommonQuestions />
      <GetYourStrategy />
      <MainSiteFooter />
    </div>;
}